import React from 'react';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';

const UNLOCK_MAILTO =
  'mailto:hello@neogtm.com?subject=' + encodeURIComponent('Unlock the full market');

export default function AccountPilotLocked({ payload }) {
  const name = payload?.account_name || 'This account';
  const message = payload?.message
    || 'Your pilot covers 10 accounts. This one is not among them, so its personas, signals, procurement history and drafted messages are not loaded.';

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="text-center max-w-lg">
        <span className="inline-flex items-center gap-1.5 text-xs font-medium text-[#5C6B7A] bg-gray-100 border border-dashed border-gray-300 rounded px-2.5 py-1">
          <Lock className="w-3.5 h-3.5" />
          Not in your pilot
        </span>
        <h1 className="mt-4 text-xl font-semibold text-[#0A1A2F]">{name}</h1>
        <p className="mt-2 text-sm text-[#5C6B7A] leading-relaxed">{message}</p>
        <div className="mt-5">
          <Button asChild className="bg-[#00C2C2] hover:bg-[#00A8A8] text-white">
            <a href={UNLOCK_MAILTO}>See what unlocking gives me</a>
          </Button>
        </div>
      </div>
    </div>
  );
}
